(function () {
  function patchUnbxdTemplate() {
    const search = window.unbxdSearch;
    const products = search?.options?.products;

    if (!products || typeof products.template !== "function") {
      return false;
    }

    if (products.template.__variantImagePatched) {
      return true;
    }

    const originalTemplate = products.template;

    function patchedTemplate(product, ...args) {
      const html = originalTemplate.call(this, product, ...args);

      const collectionMatch = window.location.pathname.match(
        /^\/collections\/([^/]+)\/?$/
      );

      const isRelevantVariant =
        product?.relevantDocument === "variant" &&
        Array.isArray(product.variants) &&
        product.variants.length === 1;

      // Preserve the original output when neither feature applies.
      if (!collectionMatch && !isRelevantVariant) {
        return html;
      }

      const container = document.createElement("div");
      container.innerHTML = html;

      // 1. Preserve collection context for all Unbxd product cards.
      if (collectionMatch) {
        const collectionHandle = collectionMatch[1];

        container.querySelectorAll("a.js-prod-link").forEach((link) => {
          const url = new URL(link.href, window.location.origin);

          if (url.origin !== window.location.origin) return;

          if (!/^\/products\/[^/]+\/?$/.test(url.pathname)) return;

          const productHandle = url.pathname.split("/")[2];

          url.pathname =
            `/collections/${collectionHandle}/products/${productHandle}`;

          link.href = url.pathname + url.search + url.hash;
        });
      }

      // 2. Preserve the existing variant image fix.
      if (isRelevantVariant) {
        const variant = product.variants[0];

        const imageUrl = window.fairwaystylesGetFirstImageUrl?.(
          variant.v_imageUrl
        );

        if (imageUrl) {
          const mainImage = container.querySelector(".card__main-image");

          if (mainImage) {
            mainImage.src =
              window.fairwaystylesWithTileWidth?.(imageUrl) || imageUrl;

            mainImage.removeAttribute("srcset");
          }

          const hoverImage = container.querySelector(".card__hover-image");
          const media = container.querySelector(".card__media");

          const images = window.fairwaystylesCoerceImagesRawList?.(
            variant.images || product.images
          ) || [];

          const mainFilename = imageUrl.split("?")[0].split("/").pop();

          const colorMatch = mainFilename.match(
            /_color_([^/.]+?)(?:_[a-z])?\.(?:jpg|jpeg|png|webp)$/i
          );

          const colorToken = colorMatch?.[1];

          const hoverUrl = colorToken
            ? images.find((url) => {
                const filename = url.split("?")[0].split("/").pop();

                return (
                  filename.includes(`_color_${colorToken}_`) &&
                  filename !== mainFilename
                );
              })
            : null;

          if (hoverImage && hoverUrl) {
            hoverImage.src =
              window.fairwaystylesWithTileWidth?.(hoverUrl) || hoverUrl;

            hoverImage.removeAttribute("srcset");
          } else {
            hoverImage?.remove();
            media?.classList.remove("has-hover-image");
          }
        }

        // 3. Preserve the relevant variant in product links.
        if (variant.variantId) {
          container.querySelectorAll(".js-prod-link").forEach((link) => {
            const url = new URL(link.href, window.location.origin);

            url.searchParams.set("variant", variant.variantId);

            link.href = url.pathname + url.search + url.hash;
          });
        }
      }

      return container.innerHTML;
    }

    patchedTemplate.__variantImagePatched = true;
    products.template = patchedTemplate;

    return true;
  }

  if (!patchUnbxdTemplate()) {
    const interval = setInterval(() => {
      if (patchUnbxdTemplate()) {
        clearInterval(interval);
      }
    }, 100);

    setTimeout(() => clearInterval(interval), 10000);
  }
})();